import superMeta from '../_DESIGN/metaDesignNode.mjs'

export default {
    ...superMeta,
    classes: ['component', ...superMeta.classes],
    ownerIdProp: '',
    ownerTextProp: '',
    ownerType: '',
}
